<template>
  <json-schema-form v-if="formValue" :value="formValue" @submit="submitHandler"/>
</template>


<script>
  export default {
    data () {
      return {
        formValue: false,
      }
    },
    mounted() {
      this.getSchemaValue(this.$route.params.id);
    },
    methods: {
      async getSchemaValue(id) {
        this.isLoading = true;

        const response = await this.$api.jschemas.getSingleByID(id);
        this.formValue = response.data[this.$route.params.id];

        this.isLoading = false;
      },
      async submitHandler(value) {
        const response = await this.$api.jschemas.update(this.$route.params.id, value);
        this.$router.push({ name: 'jschemas' });
      }
    },
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/jschemas/edit.vue